<template>
  <label for="employees-multiselect-component" class="form-label">
    {{ $t('employee.name') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedEmployee"
    :options="{
      create: false,
      placeholder: $t('employee.select')
    }"
    class="w-full"
  >
    <option :value="null" key="_null">{{ $t('employee.nullSelect') }}</option>
    <option
      v-for="employee in employees"
      :value="employee.uuid"
      :key="employee.uuid"
    >
      {{ employee.name }} {{ employee.lastname }}
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import employeeApi from '../../services/employees/employee.api'

export default defineComponent({
  data() {
    return {
      employees: []
    }
  },
  mounted() {
    employeeApi.getList(1, 1000).then(
      response => {
        this.employees = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedEmployee: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedEmployee'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedEmployee,
      set: value => emit('update:selectedEmployee', value)
    })

    return {
      componentValue
    }
  }
})
</script>
